import Vue from "vue";
import App from "./App.vue";
import router from "./starterRouter";
import "./registerServiceWorker";
//plugins
import NowUIKit from './plugins/now-ui-kit';
import retina from 'retinajs'
import VueRetina from 'vue-retina'
import VueGtag from 'vue-gtag'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'

Vue.use(VueRetina, {retina})
Vue.use(VueMaterial)

if (process.env.NODE_ENV === 'production') {

    Vue.use(VueGtag, {
        config: {id: "UA-1360084-6"}
    }, router);
}

Vue.config.productionTip = false;
Vue.use(NowUIKit);
new Vue({
    router,
    render: h => h(App)
}).$mount("#app");